<script lang="ts" setup>
const { $eventBus } = useNuxtApp()

const DEFAULT_DURATION = 3

const show = ref(false)
const closed = ref(true)
const item = ref<IEventBusSnackbar | null>(null)
const standbyQueue: IEventBusSnackbar[] = []

onBeforeMount(() => {
  $eventBus?.on<'snackbar:show'>('snackbar:show', handleShow)
  $eventBus?.on<'snackbar:hide'>('snackbar:hide', handleHide)
})

onBeforeUnmount(() => {
  $eventBus?.off<'snackbar:show'>('snackbar:show')
  $eventBus?.off<'snackbar:hide'>('snackbar:hide')
})

const handleShow = (snackbar: IEventBusSnackbar) => {
  if (closed.value) {
    closed.value = false
    item.value = snackbar
    show.value = true
  } else {
    forceCloseSnackbar()
    standbyQueue.push(snackbar)
  }
}

const handleHide = () => {
  forceCloseSnackbar()
  closed.value = true
}

const handleClickButton = () => {
  if (item.value?.handleClickButton) {
    item.value.handleClickButton()
  }
}

const handleSnackbarClosed = () => {
  resetItem()
  afterClosed()
}

const resetItem = () => {
  closed.value = true
  item.value = null
}

const afterClosed = () => {
  if (standbyQueue.length === 0) {
    return
  }

  const lastItem: IEventBusSnackbar = standbyQueue.pop() as IEventBusSnackbar
  item.value = clone(lastItem)

  standbyQueue.length = 0
  show.value = true
  closed.value = false
}

const forceCloseSnackbar = () => {
  show.value = false
}
</script>

<template>
  <BaseSnackbar
    v-model="show"
    :message="item?.message ?? ''"
    :duration="item?.duration ?? DEFAULT_DURATION"
    :icon="item?.icon"
    :button-text="item?.buttonText"
    @click:button="handleClickButton"
    @closed="handleSnackbarClosed"
  />
</template>
